import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyBkvlGDlZvpKsoLxO7eC74VHNPvg_-o_IQ",
  authDomain: "viewstream-4a119.firebaseapp.com",
  databaseURL: "https://viewstream-4a119.firebaseio.com",
  projectId: "viewstream-4a119",
  storageBucket: "viewstream-4a119.appspot.com",
  messagingSenderId: "977778340237",
  appId: "1:977778340237:web:3daa0a4b03b46483e94dc4",
  measurementId: "G-DP4YX7QLYH"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
export default firebaseApp.firestore();
// firebase.analytics();